export const useThemeClass = () => {
    const userStore = useUserStore()

    return computed(() => {
        if (userStore.theme === 'dark') return 'dark'
        if (userStore.theme === 'light') return 'light'

        return undefined
    })
}
